import React, { useContext, useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import logo from "../../Assets/logo.png";
import profilePic from "../../Assets/profileicon.png";
import { AuthContext } from "../../hooks/useLogin";
import { FaSignOutAlt } from "react-icons/fa";

const NavbarAdmin = ({ setIsSidebarOpen }) => {
  const { user } = useContext(AuthContext);
  const [userFullName, setUserFullName] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [logoutMessage, setLogoutMessage] = useState("");
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    const userData = localStorage.getItem("userData");

    if (token && userData) {
      const user = JSON.parse(userData);
      setUserFullName(user.fullname);
    }
  }, []);

  const requestLogout = () => {
    setLogoutMessage("Are you sure you want to logout?");
    setDropdownOpen(false);
  };

  const confirmLogout = () => {
    localStorage.removeItem("userToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("activePage");
    setLogoutMessage("✅ Logged out successfully!");

    setTimeout(() => {
      setLogoutMessage(null);
      navigate("/");
    }, 1500);
  };

  const closeLogoutPopup = () => {
    setLogoutMessage("");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <NavbarContainer>
      <LogoSection>
        <img src={logo} alt="INA-ANI Logo" />
        <div>
          <LogoText>INA-ANI</LogoText>
          <Tagline>Nurturing Harvests, Empowering Women</Tagline>
        </div>
      </LogoSection>

      <Title>Welcome, Administrator!</Title>

      <ProfileSection ref={dropdownRef}>
        <ProfileInfo>
          <UserName>{userFullName}</UserName>
          <ProfileRole>{user?.role || "ADMINISTRATION"}</ProfileRole>
        </ProfileInfo>
        <ProfileImage
          src={profilePic}
          alt="Profile"
          onClick={() => setDropdownOpen(!dropdownOpen)}
        />
        {dropdownOpen && (
          <Dropdown>
            <DropdownItem onClick={requestLogout}>
              <FaSignOutAlt />
              <span>Log Out</span>
            </DropdownItem>
          </Dropdown>
        )}
      </ProfileSection>
{logoutMessage && (
  <LogoutPopup>
    <PopupMessage>{logoutMessage}</PopupMessage>
    {logoutMessage === "Are you sure you want to logout?" && (
      <PopupButtons>
        <PopupButton onClick={confirmLogout}>Yes</PopupButton>
        <PopupButton onClick={closeLogoutPopup}>No</PopupButton>
      </PopupButtons>
    )}
  </LogoutPopup>
)}
    </NavbarContainer>
  );
};

export default NavbarAdmin;



// ✅ Styled Components

const NavbarContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e5e5;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  img {
    width: 50px;
    margin-left: -5px;
  }
`;

const Tagline = styled.span`
  font-size: 12px;
  color: #21551c;
  font-weight: 600;
`;

const LogoText = styled.h1`
  color: #004d00;
  font-size: 1.3rem;
  font-weight: bold;
  margin: 0;
`;

const Title = styled.h1`
  font-size: 30px;
  font-weight: bold;
  color: #21551c;
  margin-left: -50px;
`;

const ProfileSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
`;

const ProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  cursor: pointer;
`;

const UserName = styled.p`
  font-weight: bold;
  font-size: 20px;
  color: #004d00;
  margin: 0;
`;

const ProfileRole = styled.span`
  font-size: 14px;
  color: black;
  margin: 0;
`;

const ProfileImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #21551c;
  cursor: Pointer;
`;


const Dropdown = styled.div`
  position: absolute;
  top: 60px;
  right: 0;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  width: 140px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
`;

const DropdownItem = styled.div`
  padding: 10px 15px;
  cursor: pointer;
  color: #21551c;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
  &:hover {
    background-color: #eaf4e1;
  }
`;

const LogoutPopup = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  z-index: 1000;
  width: 300px;
`;


const PopupMessage = styled.p`
  font-size: 1.2rem;
  color: black;
`;

const PopupButtons = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
`;

const PopupButton = styled.button`
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  border-radius: 5px;
  background: #046600;
  color: white;

  &:hover {
    background: red;
  }
`;
